(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["titiroba-line-coupon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('titiroba-line-coupon')) {
    customElements.define('titiroba-line-coupon', class extends HTMLElement {
      connectedCallback() {
        if (this.lineController) return;
        this.lineController = new AbortController();
        const options = { signal: this.lineController.signal };
        this.lineDialog = this.querySelector('dialog');
        this.lineFloating = this.querySelector('[data-ttb-line-floating]');
        this.lineBanner = this.querySelector('.ttb-line-coupon__banner');
        this.lineTriggers = [...this.querySelectorAll('[data-ttb-line-open]')];
        this.lineDesktop = window.matchMedia('(min-width:750px)');
        this.lineDismissed = false;
        const isEditor = Boolean(window.Shopify && window.Shopify.designMode);
        if (!isEditor) {
          try { this.lineDismissed = sessionStorage.getItem('ttb-line-coupon-dismissed') === '1'; } catch (_) {}
        }
        this.syncLineFloating = () => {
          const bannerBounds = this.lineBanner.getBoundingClientRect();
          const atFinalModule = bannerBounds.height > 0 && bannerBounds.top < window.innerHeight && bannerBounds.bottom > 0;
          this.lineFloating.hidden = this.lineDismissed || this.lineDialog.open || !atFinalModule;
        };
        window.addEventListener('scroll', this.syncLineFloating, { ...options, passive: true });
        window.addEventListener('resize', this.syncLineFloating, options);
        this.lineSizeObserver = new ResizeObserver(this.syncLineFloating);
        this.lineSizeObserver.observe(document.body);
        this.syncLineFloating();
        this.syncLineMode = () => {
          this.lineTriggers.forEach((trigger) => {
            if (this.lineDesktop.matches && typeof this.lineDialog.showModal === 'function') {
              trigger.setAttribute('aria-haspopup', 'dialog');
              trigger.setAttribute('aria-controls', this.lineDialog.id);
            } else {
              trigger.removeAttribute('aria-haspopup');
              trigger.removeAttribute('aria-controls');
            }
          });
          if (!this.lineDesktop.matches && this.lineDialog.open) this.lineDialog.close();
        };
        this.lineDesktop.addEventListener('change', this.syncLineMode, options);
        this.syncLineMode();
        this.lineTriggers.forEach((trigger) => trigger.addEventListener('click', (event) => {
          if (document.documentElement.matches('.nav-open,.hside_opened') || document.querySelector('.bls__opend-popup-header,.bls__opend-popup,dialog[open]')) {
            event.preventDefault();
            return;
          }
          if (!this.lineDesktop.matches || typeof this.lineDialog.showModal !== 'function') return;
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.lineOpener = trigger;
          this.lineDialog.showModal();
          this.lineFloating.hidden = true;
          document.body.classList.add('ttb-line-coupon-modal-open');
        }, options));
        this.querySelector('[data-ttb-line-dismiss]').addEventListener('click', () => {
          this.lineDismissed = true;
          this.lineFloating.hidden = true;
          if (!isEditor) {
            try { sessionStorage.setItem('ttb-line-coupon-dismissed', '1'); } catch (_) {}
          }
        }, options);
        this.querySelector('[data-ttb-line-close]').addEventListener('click', () => this.lineDialog.close(), options);
        this.lineDialog.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const focusable = [...this.lineDialog.querySelectorAll('button:not([disabled]),a[href]')].filter((element) => element.getClientRects().length > 0);
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (!first) return;
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, options);
        this.lineDialog.addEventListener('click', (event) => {
          if (event.target !== this.lineDialog) return;
          const box = this.lineDialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.lineDialog.close();
        }, options);
        this.lineDialog.addEventListener('close', () => {
          document.body.classList.remove('ttb-line-coupon-modal-open');
          this.syncLineFloating();
          if (this.lineOpener && this.lineOpener.isConnected) this.lineOpener.focus({ preventScroll: true });
        }, options);
      }

      disconnectedCallback() {
        if (this.lineDialog && this.lineDialog.open) this.lineDialog.close();
        if (this.lineSizeObserver) this.lineSizeObserver.disconnect();
        if (this.lineController) this.lineController.abort();
        document.body.classList.remove('ttb-line-coupon-modal-open');
        this.lineController = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
